{
    "banner": {
        "title": "Nous utilisons des cookies",
        "message": "Nous utilisons des cookies pour améliorer votre expérience et analyser le trafic. Vous pouvez tout accepter ou ne conserver que les cookies essentiels.",
        "acceptAll": "Tout accepter",
        "rejectOptional": "Essentiels uniquement",
        "preferences": "Gérer les préférences",
        "essentialNote": "Les cookies essentiels restent toujours activés pour permettre la connexion, la sécurité et la langue."
    },
    "preferences": {
        "title": "Préférences des cookies",
        "essential": "Cookies essentiels (toujours activés)",
        "analytics": "Cookies d'analyse",
        "marketing": "Cookies marketing",
        "save": "Enregistrer les préférences"
    }
}
